/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

const ObserverSupported = (typeof IntersectionObserver === 'function') ? true : false;

class PostImage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            postImageSrc: '',
            isLoading: true,
            inViewport: false,
            observer: null,
            hasError: false
        };

        this.imageContainerRef = React.createRef();

        this.observerCallback = this.observerCallback.bind(this);
        this.getSrc = this.getSrc.bind(this);

    }

    componentDidMount() {
        let postImageSrc = this.getSrc();

        this.setState({
            postImageSrc
        });

    }

    componentDidUpdate(prevProps, prevState) {

        let nextSrc = this.getSrc();
        if (nextSrc !== this.state.postImageSrc) {
            this.setState({
                postImageSrc: nextSrc,
                isLoading: (this.state.inViewport) ? true : false
            });
        }

        if (this.imageContainerRef.current && this.state.observer === null && ObserverSupported) {
            let observer = new IntersectionObserver(this.observerCallback, {
                threshold: 0.1
            });

            observer.observe(this.imageContainerRef.current);

            this.setState({
                observer
            });
        } else {
            // if the browser doesn't support IntersectionObserver because it's old
            // just set the inViewport to true and let it load all the images
            if (!ObserverSupported && !this.state.inViewport) {
                this.setState({
                    inViewport: true
                });
            }
           
        }
    }

    componentWillUnmount() {
        if (this.state.observer !== null) {
            this.state.observer.disconnect();
        }
    }

    getSrc() {
        let postImageSrc = '';

        if (this.props.src) {
            postImageSrc = this.props.src;
        } else if (this.props.item.hasOwnProperty('preview') && this.props.item.preview.media && this.props.item.preview.media.length && this.props.item.preview.media[0].thumb !== '') {
            postImageSrc = this.props.item.preview.media[0].thumb;
        } else if (this.props.item.hasOwnProperty('preview') && this.props.item.preview.hasOwnProperty('itemInfo') && this.props.item.preview.itemInfo.imageThumbLink !== '') {
            if (this.props.item.preview.itemInfo.preview_display) {
                postImageSrc = this.props.item.preview.itemInfo.imageThumbLink;
            }
        } else if (this.props.item.hasOwnProperty('item')) {
            if (this.props.item.item.media && this.props.item.item.media.length) {
                postImageSrc = this.props.item.item.media[0].thumb;
            }
        }

        return postImageSrc;

    }

    observerCallback(entries) {

        entries.map((entry) => {
            if (entry.intersectionRatio > 0 && this.imageContainerRef.current && !this.state.inViewport) {
                this.state.observer.unobserve(this.imageContainerRef.current);
                this.state.observer.disconnect();
                this.setState({
                    inViewport: true,
                    observer: null
                });

            }
        });

    }

    render() {

        if (!this.state.postImageSrc) {
            return null;
        }

        if (!this.state.inViewport || this.state.hasError) {
            return (
                <div className="image-blank" ref={this.imageContainerRef}></div>
            );
        } else {
            return (
                <span>
                    <img src={this.state.postImageSrc} style={{
                            display: (this.state.isLoading) ? 'none' : 'block'
                        }} onLoad={(e) => { this.setState({isLoading: false}); }}
                            onError={() => { this.setState({hasError: true}); }}/>
                    {this.state.isLoading ? (
                        <div className="working">
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                        </div>
                    ) : null}
                </span>
            );
        }

    }

};

PostImage.propTypes = {
    item: PropTypes.object,
    src: PropTypes.string
};

PostImage.defaultProps = {
    item: {
        preview: {
            photoThumbUrl: null,
            thumbUrl: null
        }
    },
    src: null
};

export default PostImage;
